import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { getBrowserFeature } from '../../utils/getBrowserFeature';
import { ModalLargeOrMediumViewport } from './modalLargeOrMediumViewport';
import { ModalSmallViewport } from './modalSmallViewport';
import { useViewport } from '@doxyme/ui-foundation/hooks/useViewport';
const setKeyboardPolicy = ()=>{
    const { virtualKeyboard } = getBrowserFeature();
    if (virtualKeyboard) {
        virtualKeyboard.overlaysContent = true;
    }
};
/**
 * Modal provides the main container for the modal dialog, including a transition and backdrop.
 * Any contents are to be built using the exposed `<ModalHeader>`, `<ModalContent>`, `<ModalBody>`, `<ModalForm>` and `<ModalFooter>` components.
 */ export const Modal = (props)=>{
    const { verticalPosition } = props;
    const { isSmallViewport, isStable } = useViewport();
    /**
   * Right now we have to support a case when modal looks just the same way as on the
   * large viewport *but positioned at the bottom instead of center.
   */ const isSmallViewportWithoutPositioning = isSmallViewport && !Boolean(verticalPosition);
    useEffect(()=>{
        setKeyboardPolicy();
    }, []);
    /**
   * When mounting a modal onto an Iframe the viewport width always evaluates to 0 for the first few renders.
   * We wait for stable viewport detection to prevent flicker between different modal components.
   */ if (!isStable) {
        return null;
    }
    return isSmallViewportWithoutPositioning ? /*#__PURE__*/ _jsx(ModalSmallViewport, {
        ...props
    }) : /*#__PURE__*/ _jsx(ModalLargeOrMediumViewport, {
        ...props
    });
};

//# sourceMappingURL=modal.js.map